export default "__VITE_ASSET__IKfXV65v__"